module.exports = __webpack_public_path__ + "static/img/tietopalat-linnut.3b0f43c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tietopalat-linnut.jpeg
// module id = H2KG
// module chunks = 1